export const getOrigin = (order) => {
  let type = "web";
  switch (order.origin) {
    case "kiosk":
      type = order.isPOSOrder ? "POS" : "Kiosk";
      break;
    case "web":
      type = "Online Ordering";
      break;
    case "mobile-app":
      type = "On the Go App";
      break;
  }
  return type;
};

export const getOrderType = (order) => {
  let type;
  switch (order.orderType) {
    case "pickup":
      type = "Takeaway";
      break;
    default:
      type = order.orderType;
      break;
  }
  return type;
};

export const getOrderPaymentMethod = (order) => {
  let type = "EFTPOS";
  if (order && order.stripeChargeId) type = "Card(Online)";
  if (
    order &&
    order.transactionResolution &&
    order.transactionResolution.isCashOrder
  )
    type = "CASH";
  if (
    order &&
    order.transactionResolution &&
    order.transactionResolution.method
  )
    type = order.transactionResolution.method;
  return type;
};
